import StyledLink from '../StyledLink'
import { GIT_CONNECTIONS, SYSTEM } from '@eggplant/routing'
import type { Props } from '../types'

const LinkToGitConnections = ({
  children,
  isHyperlink
}: Props) =>
  <StyledLink
    isHyperlink={isHyperlink}
    to={'/' + SYSTEM + '/' + GIT_CONNECTIONS}
  >
    {children}
  </StyledLink>

export default LinkToGitConnections
